<template>
  <tbody class="ppv-assessment-tbody">
    <tr class="ppv-tr" @click="onToggleExpand(assessment)">
      <td class="ppv-td">
        <div class="ppv-assessment-name-row">
          <v-icon
            class="ppv-row-chevron"
            :class="{ open: isExpanded }"
          >
            {{ isExpanded ? icons.mdiChevronDown : icons.mdiChevronRight }}
          </v-icon>
          <span class="ppv-assessment-name">{{ assessment.token ? $t(assessment.token) : assessment.name }}</span>
        </div>
      </td>

      <td class="ppv-td ppv-td-category">
        <div class="ppv-tags-row">
          <span
            v-for="cat in assessment.diseaseCategories"
            :key="cat.name"
            class="ppv-disease-tag"
            :style="{ background: cat.categoryColor, color: cat.categoryTextColor }"
          >
            {{ cat.token ? $t(cat.token) : cat.name }}
          </span>
        </div>
      </td>

      <td class="ppv-td ppv-td-right">
        <span class="ppv-case-count">{{ assessment.totalCases }}</span>
      </td>
    </tr>

    <tr
      v-if="isExpanded"
      class="ppv-tr-detail"
    >
      <td colspan="3" class="ppv-td-detail">
        <div 
          v-for="triage in assessment.triageByConditions"
          :key="triage.triage_recommendation" 
          class="ppv-detail-indent"
        >
          <div class="ppv-detail-bar" />
          <div class="ppv-detail-content">
            <div class="ppv-triage-summary">
              <span
                class="ppv-triage-label"
                :class="'triage-' + (triage.triage_recommendation || 'standard').toLowerCase()"
              >
                {{ $t('ppv.triage.' + (triage.triage_recommendation || 'standard').toLowerCase()) }}
              </span>
              <span class="ppv-triage-summary-text">
                – {{ triage.total }}
                {{ triage.total === 1
                  ? $t('ppv.insights.positive') + ' ' + $t('ppv.insights.risk_singular')
                  : $t('ppv.insights.positive') + ' ' + $t('ppv.insights.risk_plural') }}
              </span>
            </div>
          </div>
        </div>
      </td>
    </tr>
  </tbody>
</template>

<script>
import icons from '@/mixins/icons'

export default {
  name: 'PpvAssessmentRow',
  mixins: [icons],
  props: {
    assessment: {
      type: Object,
      required: true
    },
    isExpanded: {
      type: Boolean,
      default: false
    },
    onToggleExpand: {
      type: Function,
      required: true
    },
  },
}
</script>

<style scoped>
.ppv-tr {
  cursor: pointer;
  transition: background .1s;
}
.ppv-tr:hover {
  background: #f8fafc;
}
.ppv-td {
  padding: 14px 16px;
  border-bottom: 1px solid #f0f2f5;
  vertical-align: middle;
  word-break: break-word;
}
.ppv-td-right {
  text-align: right;
  white-space: nowrap;
  vertical-align: middle;
}
.ppv-assessment-name-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.ppv-row-chevron {
  color: #c0c8d4 !important;
  font-size: 18px !important;
  flex-shrink: 0;
  transition: transform .15s;
}
.ppv-row-chevron.open {
  color: #4b91ac !important;
}
.ppv-assessment-name {
  font-weight: 700;
  font-size: 15px;
  color: #1a2340;
}
.ppv-tags-row { 
  display: flex;
  flex-wrap: wrap; 
  gap: 8px; 
}
.ppv-disease-tag {
  font-size: 11px;
  border-radius: 4px;
  padding: 2px 8px;
  background: #eef7f9;
  color: #3182ce;
  font-weight: 700;
  white-space: nowrap;
}
.ppv-case-count {
  font-size: 16px;
  font-weight: 800;
  color: #1a2340;
}
.triage-immediate {
  color: #e47921;
}
.triage-urgent {
  color: #eb1919;
}
.triage-standard {
  color: #48bb78;
}
.ppv-tr-detail > td {
  padding: 0 !important;
  border-bottom: 1px solid #f2f4f7;
}
.ppv-detail-indent {
  display: flex;
  padding: 8px 20px 20px 48px;
  position: relative;
}
.ppv-detail-bar {
  width: 2px;
  background: #eaedf2;
  border-radius: 4px;
  position: absolute;
  top: 8px;
  bottom: 20px;
  left: 22px;
}
.ppv-detail-content {
  flex: 1;
}
.ppv-triage-summary {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
}
.ppv-triage-label {
  font-weight: 700;
  text-transform: capitalize;
}
.ppv-triage-summary-text {
  color: #a0aec0;
  font-weight: 600;
}
@media (max-width: 800px) {
  .ppv-td-category {
    display: none;
  }
  .ppv-detail-indent {
    padding-left: 36px;
  }
}
</style>
